import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import AuditReportSummaryWidget from '../../../widgets/auditWidgets/auditReportSummaryWidgets/AuditReportSummaryWidget'
import { callAuditReportSummary } from '../../../redux/actions/auditReportSummary'
// import { useSearchParams } from 'react-router-dom'

export default function AuditReportSummary() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const queryString = window.location.search // ได้ "?status=1"
  const urlParams = new URLSearchParams(queryString)

  const status = urlParams.get('status')
  const year = urlParams.get('year')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await callAuditReportSummary(year, status, 1, 25)
      setSchema(response.model)

      // setSchema(mockSchema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAudit>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAudit>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isAudit>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton />

        <AuditReportSummaryWidget schema={schema} year={year} status={status} />
        <br />
      </SidebarProposal>
    </div>
  )
}
